import styled from '@emotion/styled';
import FieldError from './FieldError';
import { controlStyles } from './TextField';

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectFieldProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  placeholder?: string;
  error?: string;
  disabled?: boolean;
  'aria-label'?: string;
  'aria-describedby'?: string;
}

const Select = styled.select<{ invalid: boolean }>(({ invalid }) => ({
  ...controlStyles(invalid),
  cursor: 'pointer',
  paddingRight: '0.875rem',
}));

/**
 * Desplegable de selección única para formularios.
 *
 * Se diferencia de `FilterSelect`, que es de selección múltiple y está pensado
 * para barras de filtros.
 */
const SelectField = ({ id, value, onChange, options, placeholder, error, disabled, ...rest }: SelectFieldProps) => {
  const describedBy =
    [rest['aria-describedby'], error ? `${id}-error` : undefined].filter(Boolean).join(' ') || undefined;

  return (
    <>
      <Select
        id={id}
        value={value}
        disabled={disabled}
        invalid={!!error}
        aria-invalid={!!error}
        aria-describedby={describedBy}
        aria-label={rest['aria-label']}
        onChange={event => onChange(event.target.value)}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
      {error && <FieldError id={`${id}-error`}>{error}</FieldError>}
    </>
  );
};

export default SelectField;
